// api
import { fetchApi } from '@/api'
// actions
const adminUsersAll = (context) => {
  let url = 'admin/users'
  return fetchApi(url, [], 'GET')
    .then((response) => {
      context.commit('ADMIN_USERS_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const adminUsersDel = (context) => {
  let url = 'admin/usersdel'
  return fetchApi(url, [], 'GET')
    .then((response) => {
      context.commit('ADMIN_USERS_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const adminUsersForm = (context) => {
  let url = 'admin/users/create'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('ADMIN_USERS_FORM', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const adminUsersShow = (context, payload) => {
  let obj = JSON.parse(payload)
  let data = {}
  let url = 'admin/users/' + obj.id + '/edit'
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('ADMIN_USERS_SHOW', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const adminUsersCreate = (context, payload) => {
  let url = 'admin/users'
  return fetchApi(url, payload, 'POST')
    .then((response) => {
      context.commit('ADMIN_USERS_CREATE', response)
      window.history.back()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const adminUsersCreateIMG = (context, form) => {
  let url = 'admin/users'
  console.log('aaa', form)
  return fetchApi(url, {}, 'POST', form)
    .then((response) => {
      context.commit('ADMIN_USERS_CREATE', response)
      window.history.back()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const adminUsersUpdate = (context, payload) => {
  let obj = JSON.parse(payload)
  let url = 'admin/users/' + obj.id
  return fetchApi(url, payload, 'PUT')
    .then((response) => {
      context.commit('ADMIN_USERS_UPDATE', response)
      window.history.back()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const adminProfileUpdate = (context, payload) => {
  let obj = JSON.parse(payload)
  let url = 'profile/update'
  return fetchApi(url, payload, 'PUT')
    .then((response) => {
      context.commit('ADMIN_USERS_UPDATE', response)
      window.history.back()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const adminUsersDelete = (context, payload) => {
  let obj = JSON.parse(payload)
  let url = 'admin/users/' + obj.id
  return fetchApi(url, payload, 'DELETE')
    .then((response) => {
      context.commit('ADMIN_USERS_DELETE', response)
      location.reload()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const adminUsersprofiledata = (context) => {
  let url = 'profile'
  return fetchApi(url, [], 'POST')
    .then((response) => {
      context.commit('ADMIN_USERS_ALL', response)
    })
    .catch((error) => {
      console.error(error)
    })
}

const adminUsersProfileUpdate = (context, payload) => {
  let url = 'profile/update'
  return fetchApi(url, payload, 'PUT')
    .then((response) => {
      context.commit('ADMIN_USERS_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const inventoryProductsRestauran = (context, payloadId) => {
  let url = 'admin/products/' + payloadId + '/products'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('INVENTORY_PRODUCTS_SUBCATEGORIES', response)
      let json = response.data
      var s = document.querySelector('[name=productodefault]')
      s.innerHTML = ''
      s.options[s.options.length] = new Option('Seleccione una opcion', null)
      for (var i = 0; i < json.length; i++) {
        s.options[s.options.length] = new Option(json[i].name, json[i].id)
      }
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

export default {
  adminUsersAll,
  adminUsersForm,
  adminUsersShow,
  adminUsersCreate,
  adminUsersUpdate,
  adminUsersDelete,
  adminUsersCreateIMG,
  adminUsersprofiledata,
  adminUsersProfileUpdate,
  adminProfileUpdate,
  inventoryProductsRestauran,
  adminUsersDel
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/users/actions.js